"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPhoneNumberUpdateDtoV2 = instanceOfPhoneNumberUpdateDtoV2;
exports.PhoneNumberUpdateDtoV2FromJSON = PhoneNumberUpdateDtoV2FromJSON;
exports.PhoneNumberUpdateDtoV2FromJSONTyped = PhoneNumberUpdateDtoV2FromJSONTyped;
exports.PhoneNumberUpdateDtoV2ToJSON = PhoneNumberUpdateDtoV2ToJSON;
exports.PhoneNumberUpdateDtoV2ToJSONTyped = PhoneNumberUpdateDtoV2ToJSONTyped;
/**
 * Check if a given object implements the PhoneNumberUpdateDtoV2 interface.
 */
function instanceOfPhoneNumberUpdateDtoV2(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function PhoneNumberUpdateDtoV2FromJSON(json) {
    return PhoneNumberUpdateDtoV2FromJSONTyped(json, false);
}
function PhoneNumberUpdateDtoV2FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'receiveSms': json['receiveSms'] == null ? undefined : json['receiveSms'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}
function PhoneNumberUpdateDtoV2ToJSON(json) {
    return PhoneNumberUpdateDtoV2ToJSONTyped(json, false);
}
function PhoneNumberUpdateDtoV2ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'number': value['number'],
        'receiveSms': value['receiveSms'],
        'type': value['type'],
    };
}
//# sourceMappingURL=PhoneNumberUpdateDtoV2.js.map